import { AlertCircle, LogIn, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'

interface ErrorDisplayProps {
  error: Error | { message: string }
  onRetry?: () => void
}

export function ErrorDisplay({ error, onRetry }: ErrorDisplayProps) {
  const navigate = useNavigate()

  const isAuthError =
    error.message.includes('Token无效') ||
    error.message.includes('已过期') ||
    error.message.includes('未提供认证') ||
    error.message.includes('未授权') ||
    error.message.includes('权限不足') ||
    error.message.includes('用户不存在') // 新增：用户被删除也视为认证错误

  const handleRelogin = () => {
    // 清除本地存储的token
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')

    // 记录当前页面路径，登录后返回
    const currentPath = window.location.pathname + window.location.search
    navigate(`/login?redirect=${encodeURIComponent(currentPath)}`)
  }

  const handleRetry = () => {
    if (onRetry) {
      onRetry()
    } else {
      window.location.reload()
    }
  }

  return (
    <div className="rounded-lg bg-red-50 p-6 text-center">
      <AlertCircle className="mx-auto h-12 w-12 text-red-600" />
      <h3 className="mt-4 text-lg font-medium text-red-900">
        {isAuthError ? '身份验证失败' : '加载失败'}
      </h3>
      <p className="mt-2 text-sm text-red-700">{error.message}</p>

      {isAuthError ? (
        <Button
          onClick={handleRelogin}
          className="mt-4"
          variant="destructive"
        >
          <LogIn className="mr-2 h-4 w-4" />
          重新登录
        </Button>
      ) : (
        <Button
          onClick={handleRetry}
          className="mt-4"
          variant="destructive"
        >
          <RotateCcw className="mr-2 h-4 w-4" />
          重试
        </Button>
      )}
    </div>
  )
}
